import React from 'react';
import { useParams } from 'react-router-dom';
import { Row, Col, Typography, Empty, Button } from 'antd';
import {
  RocketOutlined,
  ArrowLeftOutlined,
  CheckCircleOutlined,
  SyncOutlined,
  ClockCircleOutlined,
} from '@ant-design/icons';
import { useDashboardNavigation } from '../../contexts/DashboardNavigationContext';
import { ProductDevelopmentComponent } from '../../components/Dashboard/ReportingComponents';
import { DashboardSectionCard } from '../../components/Dashboard/DashboardSectionCard';
import styles from './DevelopmentDashboard.module.css';

const { Title, Text } = Typography;

// ============================================================================
// DEVELOPMENT DASHBOARD
// ============================================================================

export const DevelopmentDashboard: React.FC = () => {
  const { productId } = useParams<{ productId: string }>();
  const { currentLocation, goBack } = useDashboardNavigation();

  if (!productId) {
    return (
      <div className={styles.emptyContainer}>
        <Empty
          description="No product selected"
          image={Empty.PRESENTED_IMAGE_SIMPLE}
        >
          <Button type="primary" icon={<ArrowLeftOutlined />} onClick={goBack}>
            Go Back
          </Button>
        </Empty>
      </div>
    );
  }

  const productName = currentLocation.productName || 'Product';

  return (
    <div className={styles.dashboard}>
      {/* Dashboard Header */}
      <div className={styles.header}>
        <div className={styles.headerContent}>
          <RocketOutlined className={styles.headerIcon} />
          <div>
            <Title level={2} className={styles.title}>
              Development - {productName}
            </Title>
            <Text className={styles.subtitle}>
              Product releases, objectives, and development status
            </Text>
          </div>
        </div>
      </div>

      {/* Main Development Component */}
      <div className={styles.mainContent}>
        <ProductDevelopmentComponent
          artifactId={productId}
        />
      </div>

      {/* Quick Status Cards */}
      <Row gutter={[24, 24]}>
        <Col xs={24} sm={12} lg={6}>
          <DashboardSectionCard
            title="Completed"
            icon={<CheckCircleOutlined style={{ color: '#22c55e' }} />}
            metrics={[{ label: 'Releases', value: '—' }]}
          />
        </Col>
        <Col xs={24} sm={12} lg={6}>
          <DashboardSectionCard
            title="In Progress"
            icon={<SyncOutlined spin style={{ color: '#818cf8' }} />}
            metrics={[{ label: 'Active', value: '—' }]}
          />
        </Col>
        <Col xs={24} sm={12} lg={6}>
          <DashboardSectionCard
            title="Planned"
            icon={<ClockCircleOutlined style={{ color: '#fbbf24' }} />}
            metrics={[{ label: 'Upcoming', value: '—' }]}
          />
        </Col>
        <Col xs={24} sm={12} lg={6}>
          <DashboardSectionCard
            title="Total Items"
            icon={<RocketOutlined />}
            metrics={[{ label: 'All Releases', value: '—' }]}
          />
        </Col>
      </Row>
    </div>
  );
};

export default DevelopmentDashboard;
